import { createStandardAction } from 'typesafe-actions';

import type { TealiumObject } from '@travel/traveler-core/hooks/useTealium';

import type { SeoData } from 'Seo-Types';

export const updateSEOData = createStandardAction('UPDATE_SEO_DATA').map((payload: SeoData) => ({
  payload,
}));

export const setDefaultSEOData = createStandardAction('SET_DEFAULT_SEO_DATA').map(() => ({
  payload: {},
}));

export const setDataLayer = createStandardAction('SET_DATA_LAYER')<TealiumObject>();

export const resetDataLayer = createStandardAction('RESET_DATA_LAYER').map(() => ({
  payload: {},
}));
